// extracted by mini-css-extract-plugin
module.exports = {"logout":"logout_logout__1FrdY","text":"logout_text__2XZRc","img":"logout_img__1G_Dw","btns":"logout_btns__1OtfV","btn":"logout_btn__3KQ_Z"};